import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, branch, renderComponent, lifecycle } from 'recompose';
import { mapDispatchToActions } from '@sparefoot/react-core/utils';
import {
	getFacilityPhoneNumber,
	getFacilityCardPhoneNumber,
} from 'store/modules/facilities';
import { getTollfreePhoneNumber } from 'store/modules/phone';

import { LoadingMask } from 'components/core/LoadingMask';
import { NewFacilityCard } from 'components/facility/FacilityCard';
import FacilityCard from 'components/organisms/FacilityCard';
import NoResults from 'components/search/SearchResults/NoResults';

import './SearchResults.scss';
import { TrackingClient } from '@sparefoot/tracking-client';

export const enhance = compose(
	connect(
		undefined,
		{
			getFacilityPhoneNumber,
			getTollfreePhoneNumber,
			getFacilityCardPhoneNumber,
		},
		mapDispatchToActions,
	),
	branch(({ facilities }) => !facilities.length, renderComponent(NoResults)),

	lifecycle({
		componentDidMount() {
			let facilitiesList = this.props?.facilities?.map(
				(facility) => facility.id,
			);
			let facilities = this.props?.facilities.map((facility) => ({
				id: facility.id,
				name: facility.name,
				location: facility.location.id,
				facility_rank: facility.facilityRank,
			}));
			TrackingClient.trackFacilityListViewed({
				facilities,
				facilities_list: facilitiesList,
				search_term: this.props?.searchParams?.location,
			});
		},
	}),
);

export function SearchResults({
	actions,
	facilities,
	baseUrl,
	cloudfrontUrl,
	facilitySelected,
	handleFacilityCardVisible,
	handleFacilityDeselected,
	handleFacilitySelected,
	handlePinDeselected,
	handlePinSelected,
	isCLP,
	loading,
	location,
	searchType,
	searchParams,
	isNewSearchPage, // sf_16978_ssdc_clp_redesign
}) {
	const handleFacilityCardPhoneNumber = (facilityId) => () =>
		actions.getFacilityCardPhoneNumber(
			location.city,
			location.state,
			facilityId,
		);
	return (
		<div className="search-results">
			{loading && <LoadingMask />}
			{facilities.map((facility, index) => (
				<div
					id={`facility-card-${facility.id}`}
					key={`facility-card-wrapper-${facility.id}`}
					className="facility-card-wrapper"
				>
					{isNewSearchPage ? (
						<FacilityCard
							facility={facility}
							baseUrl={baseUrl}
							facilitySelected={facilitySelected}
							getFacilityCardPhoneNumber={handleFacilityCardPhoneNumber(
								facility.id,
							)}
							handleFacilityDeselected={handleFacilityDeselected}
							handleFacilitySelected={handleFacilitySelected}
							handlePinDeselected={handlePinDeselected}
							handlePinSelected={handlePinSelected}
							lazyLoad
							rank={index + 1}
							loading={loading}
							onVisible={handleFacilityCardVisible}
							storageType={searchType}
							searchParams={searchParams}
							withSchema={isCLP}
							hasOMI={facility.hasOnlineMoveins}
							cloudfrontUrl={cloudfrontUrl}
						/>
					) : (
						<NewFacilityCard
							facility={facility}
							baseUrl={baseUrl}
							facilitySelected={facilitySelected}
							getFacilityCardPhoneNumber={handleFacilityCardPhoneNumber(
								facility.id,
							)}
							handleFacilityDeselected={handleFacilityDeselected}
							handleFacilitySelected={handleFacilitySelected}
							handlePinDeselected={handlePinDeselected}
							handlePinSelected={handlePinSelected}
							lazyLoad
							rank={index + 1}
							loading={loading}
							onVisible={handleFacilityCardVisible}
							storageType={searchType}
							searchParams={searchParams}
							withSchema={isCLP}
							hasOMI={facility.hasOnlineMoveins}
							cloudfrontUrl={cloudfrontUrl}
						/>
					)}
				</div>
			))}
		</div>
	);
}

SearchResults.propTypes = {
	actions: PropTypes.shape({
		getFacilityCardPhoneNumber: PropTypes.func.isRequired,
	}).isRequired,
	facilities: PropTypes.arrayOf(PropTypes.object),
	baseUrl: PropTypes.string,
	cloudfrontUrl: PropTypes.string,
	facilitySelected: PropTypes.number,
	handleFacilityDeselected: PropTypes.func,
	handleFacilityCardVisible: PropTypes.func,
	handleFacilitySelected: PropTypes.func,
	handlePinDeselected: PropTypes.func,
	handlePinSelected: PropTypes.func,
	isCLP: PropTypes.bool,
	loading: PropTypes.bool,
	location: PropTypes.object.isRequired,
	searchType: PropTypes.string,
	searchParams: PropTypes.object,
	isNewSearchPage: PropTypes.bool,
};

export default enhance(SearchResults);
